import React from "react"
import CustomButton from "../../../../../ui/atoms/Button"
import CustomCheckbox from "../../../../../ui/atoms/Checkbox"
import Typography from "../../../../../ui/atoms/Typography"
import { CheckboxFilterOption } from "../types"

interface Props {
  option: CheckboxFilterOption
  selected: boolean
  onClick?: () => void
  className?: string
}

const CheckboxFilterItem = ({
  option,
  selected,
  onClick,
  className,
}: Props) => {
  return (
    <CustomCheckbox
      value={selected}
      onChange={() => onClick?.()}
      className={className}
      alignTop={false}
      disabled={option.occurrences === 0}
    >
      <CustomButton
        variant="text"
        invariantCase
        noMinWidth
        preventDefault
        onClick={() => onClick?.()}
        disabled={option.occurrences === 0}
      >
        <Typography variant="body1" weight="normal" className="truncate">
          {option.label} ({option.occurrences})
        </Typography>
      </CustomButton>
    </CustomCheckbox>
  )
}

export default CheckboxFilterItem
